<template>
  <router-link v-if="!isExternal" :to="{ name: href }" class="button btnPush" @mouseover="playSound" ><slot /></router-link>
  <a v-else target="_blank" :href="href" class="button btnPush" @mouseover="playSound" @click="() => $emit('click')" ><slot /></a>
</template>

<script>
  export default {
    props: [ 'href'],
    computed: {
      isExternal() {
        return this.href.indexOf('http') === 0
      }
    },
    methods: {
      playSound () {
        var sound = document.getElementById("beep")
        sound.play();
      }
    }
  }
</script>

<style scoped>
  .button {
    display: inline-block;
    position: relative;
    padding: 15px 30px;
    margin: 10px 20px 10px 0;
    font-size: 18px;
    text-align: center;
    text-decoration: none;
    color: #FFF;
    border-radius: 10px;
    transition: all 0.2s ;
    background: #de2128;
    font-family: 'blogger_sansbold';
  }

  .btnPush {
    box-shadow: 0px 8px 0px 0px #7f0004;
  }

  .btnPush:hover {
    margin-top: 15px;
    margin-bottom: 5px;
    box-shadow: 0px 0px 0px 0px #7f0004;
  }
  
  .button.return {
    background: #bababa;
    box-shadow: 0px 8px 0px 0px #8b8b8b;
  }
  .button.return:before {
    content: "\f104";
    font: normal normal normal 21px/1 "Font Awesome 5 Free";
    display: inline-block;
    margin-right: 10px;
    top: 1px;
    position: relative;
    font-weight: 900;
  }
  .button.return:hover { background: #de2128;box-shadow: 0px 0px 0px 0px #7f0004; }
  
</style>
